<template>
  <div>
    <ItemHeader
      title="Должник"
      :expand="v.expand.$model"
      :btn-delete-visible="canDelete"
      btn-delete-text="Удалить должника"
      @btn-expand-click="v.expand.$model = !v.expand.$model"
      @btn-delete-click="$emit('delete')"
    />
    <v-expand-transition>
      <div v-show="v.expand.$model">
        <div class="form-section-base__controls" v-if="isMrpaEnable">
          <v-row>
            <v-col>
              <v-radio-group v-model="v.fillType.$model" row>
                <v-radio label="Должник" :value="SubjectFillType.MANUAL" />
                <v-radio
                  label="Представитель по доверенности в машиночитаемом виде"
                  :value="SubjectFillType.MACHINE"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </div>

        <Manual
          v-if="v.fillType.$model === SubjectFillType.MANUAL"
          :v="v.manual"
        />

        <Machine
          v-if="v.fillType.$model === SubjectFillType.MACHINE"
          :v="v.machine"
          @parsed-mrpa-change="$emit(AppEvent.PARSED_MRPA_CHANGE, $event)"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import ItemHeader from '@/components/services/elements/ItemHeader';
import Manual, { manualModel, getManualValidation } from './Manual';
import Machine, { machineModel, getMachineValidation } from './Machine';
import { StatementType, SubjectFillType } from '@/constants';
import { isMrpaEnable } from '@/app.config';
import { AppEvent } from '@/constants';

export const debtorModel = {
  expand: true,
  fillType: SubjectFillType.MANUAL,
  manual: manualModel,
  machine: machineModel,
};

const getDebtorBaseValidation = () => ({
  expand: {},
  fillType: {},
});

export const getDebtorValidation = (debtor) => {
  if (debtor.fillType === SubjectFillType.MANUAL) {
    return {
      ...getDebtorBaseValidation(),
      manual: getManualValidation(debtor.manual),
    };
  }

  return {
    ...getDebtorBaseValidation(),
    machine: getMachineValidation(debtor.machine),
  };
};

export default {
  name: 'Debtor',
  components: {
    ItemHeader,
    Machine,
    Manual,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    AppEvent,
    SubjectFillType,
  }),
  computed: {
    isMrpaEnable() {
      return isMrpaEnable(StatementType.ACCEPTANCE_ESCROW);
    },
  },
};
</script>
